<template>
  <div class="box variant-add-ons">
      <a
        v-if="canEdit && step !== 0"
        href="#"
        class="edit"
        @click.prevent="$emit('edit')"
      >
        {{ tc('booking.edit') }}
      </a>
      <div class="section-label capitalize">
        {{ titleLabel }}
      </div>
      <div class="overview-items-wrapper">
        <see-details>
          <template slot-scope="{ opened }">
            <div
              v-for="addOn in addOns"
              :key="addOn.sitecoreId"
              class="add-on-item"
              :class="{'mb-3': opened}"
            >
              <div class="overview-item" :class="{'mb-2': opened, 'mb-3': !opened}">
                <span class="item label bold-item add-on__name">{{ addOn.addOnName }}</span>
                <span class="item-value bold-item add-on__total">{{ getAddOnsTotal(addOn) }}</span>
              </div>
              <transition name="expand-y">
              <template v-if="opened">
                  <div class="overview-items-wrapper">
                    <div class="overview-item add-on__price-type">
                      <span class="section-label">{{ getPriceAndTypeLabel(addOn) }}</span>
                    </div>
                    <div class="overview-item small-margin">
                      <span>{{ quantityLabel }}: {{ getTotalQuantity(addOn) }}</span>
                    </div>
                    <div class="overview-item small-margin" v-if="addOn.adultQuantity">
                      <span class="section-label">{{ adultsLabel }}: {{ addOn.adultQuantity }}</span>
                    </div>
                    <div class="overview-item small-margin" v-if="addOn.childQuantity">
                      <span class="section-label add-on__child-quantity">
                        {{ childrenLabel }}: {{ addOn.childQuantity }}
                        <v-dropdown
                          v-if="addOn.excludeKidsFromPriceCalculations && tooltipMessage !== ''"
                          class="tooltip tooltip-variant--add-on-footer"
                          :distance="25"
                          :skidding="0"
                          placement="top"
                        >
                        <button
                          class="tooltip-icon icon-info"
                          :aria-label="tooltipMessage"
                        />

                        <template #popper>
                          <div class="tooltip-variant--add-on-footer tooltip-content">
                            <div class="tooltip-header">
                              <button
                                v-close-popper
                                :aria-label="tc('booking.close')"
                                tabindex="0"
                                class="icon-close"
                              />
                            </div>
                            <div class="tooltip-body">
                              {{ tooltipMessage }}
                            </div>
                          </div>
                        </template>
                      </v-dropdown>
                      </span>
                    </div>
                    <template v-if="addOn.data.selectedAddOnDates && addOn.data.selectedAddOnDates.length > 0">
                      <div class="overview-item small-margin">
                          <span>{{ datesLabel }}</span>
                      </div>
                      <div v-for="date in addOn.data.selectedAddOnDates" :key="date" class="overview-item small-margin">
                        <span class="section-label">{{ dateFormatted(date) }}</span>
                      </div>
                    </template>
                  </div>
                </template>
              </transition>
            </div>
          </template>
        </see-details>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SeeDetails from '../../../components/see-details/see-details.vue'
  import { formatDateZone } from "@utils/date-helpers";

  export default {
    name: 'AddOnsOverview',
    components: {
      SeeDetails
    },
    props: {
      addOns: {
        type: Array,
        required: true
      },
      canEdit: Boolean
    },
    computed: {
      ...mapState('auth', ['addOnsComponentData']),
      ...mapState('booking', ['step']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('currency', ['getDisplayPrice', 'currencyData']),
      titleLabel() {
        return this.addOnsComponentData?.AddOnsTitle || ""
      },
      datesLabel() {
        return this.addOnsComponentData?.DateLabel || ""
      },
      quantityLabel() {
        return this.addOnsComponentData?.QuantityLabel || ""
      },
      adultsLabel() {
        return this.addOnsComponentData?.AdultLabel || ""
      },
      childrenLabel() {
        return this.addOnsComponentData?.ChildLabel || ""
      },
      tooltipMessage() {
        return this.addOnsComponentData?.TooltipChildrenNotIncluded || ''
      }
    },
    methods: {
      getPriceFormatted(price) {
        return this.getDisplayPrice({ price })
      },
      getServicePricingTypeLabel(addOn) {
        return this.addOnsComponentData?.ServicePricingType[addOn?.servicePricingType] || ""
      },
      dateFormatted(date) {
        return formatDateZone(date, null, "ddd, D MMM, YYYY")
      },
      getTotalQuantity(addOn) {
        if (addOn.airportAddOn || addOn.servicePricingType === 'per-night' || addOn.servicePricingType === 'per-stay') {
          return Number(addOn?.quantity)
        }
        return Number(addOn?.adultQuantity) + Number(addOn?.childQuantity)
      },
      getPriceAndTypeLabel(addOn) {
        return addOn.airportAddOn
          ? this.getPriceFormatted(addOn.price[0])
          : `${this.getPriceFormatted(addOn.price[0])} / ${this.getServicePricingTypeLabel(addOn)}`
      },
      getAddOnsTotal(addOn) {
        const totalWithoutTax = addOn.total - addOn.totalTax
        return this.getPriceFormatted(totalWithoutTax)
      }
    }
  }
</script>
